import { type FC, Suspense, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '#components/Button'
import { Spinner } from '#components/Spinner'
import type { ErrorDescription } from './errorHelpers'
import { LazyReportErrorDialog } from './LazyReportErrorDialog'
import { reportButtonClass } from './toastError'

export const ReportHandler: FC<{ errorInfo: ErrorDescription[] }> = ({ errorInfo }) => {
  const [isReportDialogOpen, setIsReportDialogOpen] = useState(false)
  const { t } = useTranslation('shared')

  return (
    <Suspense
      fallback={
        <Button size="xs" className={reportButtonClass} disabled>
          {t('error-handler.button.report', 'Report')}
          <Spinner size="xs" />
        </Button>
      }
    >
      <Button
        size="xs"
        className={reportButtonClass}
        onClick={(e) => {
          e.stopPropagation()
          setIsReportDialogOpen(true)
        }}
      >
        {t('error-handler.button.report', 'Report')}
      </Button>
      {isReportDialogOpen && <LazyReportErrorDialog errorInfo={errorInfo} onOpenChange={setIsReportDialogOpen} isOpen={isReportDialogOpen} />}
    </Suspense>
  )
}
